import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ProductData } from "./types/index.js";
import { Section } from "../reusableComponents/Section/index.js";
import { ProductsTableMobile } from "./productsMobileView/index.js";
import { ProductsTableDesktop } from "./productsDesktopView/index.js";

const ProductsTable = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (document.documentElement.clientWidth <= 768) {
      setIsMobile(true);
    }
  }, []);

  return (
    <Section title="My Products">
      {isMobile ? (
        <ProductsTableMobile data={data} />
      ) : (
        <ProductsTableDesktop data={data} />
      )}
    </Section>
  );
};

ProductsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape(ProductData)).isRequired,
};

export default ProductsTable;
